module.exports = __webpack_public_path__ + "static/media/roborace.5cbdfd05.png";